import { StarIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

/** Empty state shown when a replayed session has no rating. */
export const NoRatingEmpty = () => {
  const { t } = useTranslation();

  return (
    <Empty className="justify-start px-0 py-12">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <StarIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('try_it.review.no_rating_title')}</EmptyTitle>
        <EmptyDescription>{t('try_it.review.no_rating_body')}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
